import { isBootFeatureEnabled } from 'owa-metatags';
import { logUsageFromAccounts, logGreyErrorFromAccounts } from 'owa-account-analytics';
import { pluggableAccountFunctions } from './pluggableAccountFunctions';

let isEnabled: boolean | undefined;

export function isSovereignCloudInfraEnabled(): boolean {
    if (isEnabled === undefined) {
        logGreyErrorFromAccounts(
            'SovereignCloudInfraCheckBeforeInit',
            pluggableAccountFunctions?.tryGetGlobalSettingsAccountMailboxInfo?.()
        );
        isEnabled = false;
    }
    return isEnabled;
}

/**
 * Called during account source list initialization to compute the
 * enablement decision from the boot flight and account state.
 * No-op if the decision was already set (e.g. via
 * setSovereignCloudInfraDecision on the data worker).
 */
export function initializeSovereignCloudInfra(accountState: {
    hasNoAccounts: boolean;
    allFirstPartyAccountsHaveIdentifiers: boolean;
}): void {
    if (isEnabled !== undefined) {
        return;
    }

    const hasBootFlight = isBootFeatureEnabled('acct-sovereignCloudInfraV3');
    const prerequisiteMet =
        accountState.hasNoAccounts || accountState.allFirstPartyAccountsHaveIdentifiers;

    isEnabled = hasBootFlight && prerequisiteMet;

    logUsageFromAccounts(
        'SovereignCloudInfraDecision',
        pluggableAccountFunctions?.tryGetGlobalSettingsAccountMailboxInfo?.(),
        {
            hasBootFlight,
            ...accountState,
            isEnabled,
        }
    );
}

/**
 * Called during data worker initialization to set the pre-computed
 * decision from the main thread, ensuring both contexts agree.
 * Once set, initializeSovereignCloudInfra becomes a no-op because
 * isEnabled is already defined.
 */
export function setSovereignCloudInfraDecision(enabled: boolean): void {
    isEnabled = enabled;
}

/** @internal Test-only. */
export function resetSovereignCloudInfraForTests(): void {
    isEnabled = undefined;
}
